"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const bridge_1 = require("@completeanatomy/bridge");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const atoms_1 = require("../../atoms");
const hooks_1 = require("../../hooks");
function ExitButton({ visible }) {
    const { isMobile } = (0, device_1.usePlatform)();
    const bridge = (0, bridge_1.useBridge)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const isArModeActive = (0, hooks_1.useIsARModeActive)();
    (0, react_1.useEffect)(() => {
        if (!isArModeActive) {
            navigate(-1);
        }
    }, [navigate, isArModeActive]);
    const onBackHandler = () => bridge === null || bridge === void 0 ? void 0 : bridge.liveModeBackAction();
    return ((0, jsx_runtime_1.jsx)(TopPanel, { "$isMobile": isMobile, "data-e2e": 'ExitButton_TopPanel', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: visible, timeout: 200, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ExitButton_CSSTransition', children: (0, jsx_runtime_1.jsx)(CloseButton, { "$isMobile": isMobile, iconName: ui_1.Icons.Live_Mode_X, onClick: onBackHandler, "data-e2e": 'ExitButton_CloseButton' }) }) }));
}
exports.default = ExitButton;
const TopPanel = styled_components_1.default.div `
  display: flex;
  flex-direction: ${props => (props.$isMobile ? 'row' : 'column')};
  justify-content: flex-start;
`;
const CloseButton = (0, styled_components_1.default)(atoms_1.ArModeButton) `
  ${props => props.$isMobile
    ? (0, styled_components_1.css) `
          width: 45px;
          height: 45px;
        `
    : ''}

  &.enter {
    transform: scale(0);
    opacity: 0;
  }

  &.enter-active {
    transform: initial;
    opacity: 1;

    transition: all 0.15s ease-in-out;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    transform: scale(0);
    opacity: 0;

    transition: all 0.15s ease-in-out;
  }
`;
